import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { FaHome, FaClipboardCheck, FaChartBar, FaUpload, FaClock, FaBullhorn, FaUserGraduate, FaFileAlt, FaEnvelope, FaChalkboard } from 'react-icons/fa';
import TeacherDashboard from './Dashboard';
import Analytics        from './Analytics';
import Attendance       from './Attendance';
import Marks            from './Marks';
import Materials        from './Materials';
import Timetable        from './Timetable';
import TeacherNotices   from './Notices';
import ClassNotices     from './ClassNotices';
import Behaviour        from './Behaviour';
import ReportCards      from './ReportCards';
import TeacherMessages  from './Messages';

const navItems = [
  { type: 'section', label: 'Overview' },
  { to: '/teacher',                label: 'Dashboard',      icon: FaHome },
  { to: '/teacher/analytics',      label: 'Analytics',      icon: FaChartBar },
  { type: 'section', label: 'Teaching' },
  { to: '/teacher/attendance',     label: 'Attendance',     icon: FaClipboardCheck },
  { to: '/teacher/marks',          label: 'Marks',          icon: FaChartBar },
  { to: '/teacher/report-cards',   label: 'Report Cards',   icon: FaFileAlt },
  { type: 'section', label: 'Resources' },
  { to: '/teacher/materials',      label: 'Study Materials',icon: FaUpload },
  { to: '/teacher/timetable',      label: 'Timetable',      icon: FaClock },
  { type: 'section', label: 'Learner Welfare' },
  { to: '/teacher/behaviour',      label: 'Behaviour',      icon: FaUserGraduate },
  { type: 'section', label: 'Communication' },
  { to: '/teacher/class-notices',  label: 'Class Notices',  icon: FaChalkboard },
  { to: '/teacher/notices',        label: 'School Notices', icon: FaBullhorn },
  { to: '/teacher/messages',       label: 'Messages',       icon: FaEnvelope },
];

export default function TeacherApp() {
  return (
    <DashboardLayout sidebarItems={navItems}>
      <Routes>
        <Route index                element={<TeacherDashboard />} />
        <Route path="analytics"    element={<Analytics />} />
        <Route path="attendance"    element={<Attendance />} />
        <Route path="marks"         element={<Marks />} />
        <Route path="materials"     element={<Materials />} />
        <Route path="timetable"     element={<Timetable />} />
        <Route path="notices"          element={<TeacherNotices />} />
        <Route path="class-notices"    element={<ClassNotices />} />
        <Route path="messages"         element={<TeacherMessages />} />
        <Route path="behaviour"     element={<Behaviour />} />
        <Route path="report-cards"  element={<ReportCards />} />
        <Route path="*"             element={<Navigate to="/teacher" replace />} />
      </Routes>
    </DashboardLayout>
  );
}
